// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/template_builder_lib.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/template_builder_lib.proto.
 */
export const file_inventory_v1_template_builder_lib: GenFile = /*@__PURE__*/
  fileDesc("CidpbnZlbnRvcnkvdjEvdGVtcGxhdGVfYnVpbGRlcl9saWIucHJvdG8SDGludmVudG9yeS52MSI5ChVUZW1wbGF0ZUJ1aWxkZXJPcHRpb24SCgoCaWQYASABKAkSFAoMZGlzcGxheV9uYW1lGAIgASgJIoUBChhUZW1wbGF0ZUJ1aWxkZXJDb25kaXRpb24SEwoLcXVlc3Rpb25faWQYASABKAkSQAoIb3BlcmF0b3IYAiABKA4yLi5pbnZlbnRvcnkudjEuVGVtcGxhdGVCdWlsZGVyQ29uZGl0aW9uT3BlcmF0b3ISEgoKb3B0aW9uX2lkcxgDIAMoCSrsAgobVGVtcGxhdGVCdWlsZGVyUXVlc3Rpb25UeXBlEi4KKlRFTVBMQVRFX0JVSUxERVJfUVVFU1RJT05fVFlQRV9VTlNQRUNJRklFRBAAEjAKLFRFTVBMQVRFX0JVSUxERVJfUVVFU1RJT05fVFlQRV9TSU5HTEVfU0VMRUNUEAESLworVEVNUExBVEVfQlVJTERFUl9RVUVTVElPTl9UWVBFX01VTFRJX1NFTEVDVBACEiwKKFRFTVBMQVRFX0JVSUxERVJfUVVFU1RJT05fVFlQRV9GUkVFX1RFWFQQAxI3CjNURU1QTEFURV9CVUlMREVSX1FVRVNUSU9OX1RZUEVfQ09NUEFOWV9BVVRPQ09NUExFVEUQBBIqCiZURU1QTEFURV9CVUlMREVSX1FVRVNUSU9OX1RZUEVfQ09OVEFDVBAFEicKI1RFTVBMQVRFX0JVSUxERVJfUVVFU1RJT05fVFlQRV9EQVRFEAYqwQEKIFRlbXBsYXRlQnVpbGRlckNvbmRpdGlvbk9wZXJhdG9yEjMKL1RFTVBMQVRFX0JVSUxERVJfQ09ORElUSU9OX09QRVJBVE9SX1VOU1BFQ0lGSUVEEAASMQotVEVNUExBVEVfQlVJTERFUl9DT05ESVRJT05fT1BFUkFUT1JfSVNfT05FX09GEAESNQoxVEVNUExBVEVfQlVJTERFUl9DT05ESVRJT05fT1BFUkFUT1JfSVNfTk9UX09ORV9PRhACQr8BChBjb20uaW52ZW50b3J5LnYxQhdUZW1wbGF0ZUJ1aWxkZXJMaWJQcm90b1ABWkFnaXRodWIuY29tL2xlbWEuYWkvbGVtbWF0YS9hcGkvcHJvdG8vZ2VuL2ludmVudG9yeS92MTtpbnZlbnRvcnl2MaICA0lYWKoCDEludmVudG9yeS5WMcoCDEludmVudG9yeVxWMeICGEludmVudG9yeVxWMVxHUEJNZXRhZGF0YeoCDUludmVudG9yeTo6VjFiBnByb3RvMw");

/**
 * @generated from message inventory.v1.TemplateBuilderOption
 */
export type TemplateBuilderOption = Message<"inventory.v1.TemplateBuilderOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;
};

/**
 * Describes the message inventory.v1.TemplateBuilderOption.
 * Use `create(TemplateBuilderOptionSchema)` to create a new message.
 */
export const TemplateBuilderOptionSchema: GenMessage<TemplateBuilderOption> = /*@__PURE__*/
  messageDesc(file_inventory_v1_template_builder_lib, 0);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * Defines when a question should be visible based on a previous question's answer.
 * The referenced question must appear before this question in the template order
 * and must have options
 * Chaining is allowed (C depends on B depends on A) as long as each reference
 * points to a question with a lower global index.
 *
 * @generated from message inventory.v1.TemplateBuilderCondition
 */
export type TemplateBuilderCondition = Message<"inventory.v1.TemplateBuilderCondition"> & {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId: string;

  /**
   * @generated from field: inventory.v1.TemplateBuilderConditionOperator operator = 2;
   */
  operator: TemplateBuilderConditionOperator;

  /**
   * @generated from field: repeated string option_ids = 3;
   */
  optionIds: string[];
};

/**
 * Describes the message inventory.v1.TemplateBuilderCondition.
 * Use `create(TemplateBuilderConditionSchema)` to create a new message.
 */
export const TemplateBuilderConditionSchema: GenMessage<TemplateBuilderCondition> = /*@__PURE__*/
  messageDesc(file_inventory_v1_template_builder_lib, 1);

/**
 * All supported question types by template builder
 *
 * @generated from enum inventory.v1.TemplateBuilderQuestionType
 */
export enum TemplateBuilderQuestionType {
  /**
   * @generated from enum value: TEMPLATE_BUILDER_QUESTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEMPLATE_BUILDER_QUESTION_TYPE_SINGLE_SELECT = 1;
   */
  SINGLE_SELECT = 1,

  /**
   * @generated from enum value: TEMPLATE_BUILDER_QUESTION_TYPE_MULTI_SELECT = 2;
   */
  MULTI_SELECT = 2,

  /**
   * @generated from enum value: TEMPLATE_BUILDER_QUESTION_TYPE_FREE_TEXT = 3;
   */
  FREE_TEXT = 3,

  /**
   * Company name autocomplete powered by PDL search.
   *
   * @generated from enum value: TEMPLATE_BUILDER_QUESTION_TYPE_COMPANY_AUTOCOMPLETE = 4;
   */
  COMPANY_AUTOCOMPLETE = 4,

  /**
   * A contact field capturing name + email.
   *
   * @generated from enum value: TEMPLATE_BUILDER_QUESTION_TYPE_CONTACT = 5;
   */
  CONTACT = 5,

  /**
   * @generated from enum value: TEMPLATE_BUILDER_QUESTION_TYPE_DATE = 6;
   */
  DATE = 6,
}

/**
 * Describes the enum inventory.v1.TemplateBuilderQuestionType.
 */
export const TemplateBuilderQuestionTypeSchema: GenEnum<TemplateBuilderQuestionType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_template_builder_lib, 0);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from enum inventory.v1.TemplateBuilderConditionOperator
 */
export enum TemplateBuilderConditionOperator {
  /**
   * @generated from enum value: TEMPLATE_BUILDER_CONDITION_OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEMPLATE_BUILDER_CONDITION_OPERATOR_IS_ONE_OF = 1;
   */
  IS_ONE_OF = 1,

  /**
   * @generated from enum value: TEMPLATE_BUILDER_CONDITION_OPERATOR_IS_NOT_ONE_OF = 2;
   */
  IS_NOT_ONE_OF = 2,
}

/**
 * Describes the enum inventory.v1.TemplateBuilderConditionOperator.
 */
export const TemplateBuilderConditionOperatorSchema: GenEnum<TemplateBuilderConditionOperator> = /*@__PURE__*/
  enumDesc(file_inventory_v1_template_builder_lib, 1);

